import { css } from '@emotion/css';
import { DateTitleWithEndTimes } from 'Shared/frontend/PosterTitle';
import { palette, theme } from 'Shared/frontend/SettingsProvider';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { specialPosterUrl } from 'Shared/frontend/specialsPosters/SpecialsPoster';
import { Show } from 'solid-js';

const imgStyle = () => css({
	width: '100%'
});

const detailsStyle = () => css({
	fontSize: 20,
	padding: '1.5em 1em 0.5em 1em'
});

const specialNameStyle = () => css({
	color: palette().feature,
	paddingBottom: '0.5em',
	fontSize: '1.2em',
	textTransform: 'uppercase'
});

const dateStyle = () => css({
	fontSize: '0.7em',
	textTransform: 'uppercase',
	paddingBottom: '2em'
});

const taglineStyle = () => css({
	fontSize: '0.9em'
});

const moreEventTaglineStyle = () => css(theme().text.plain, {
//	fontSize: '0.9em'
});


export function SpecialsOverlayContent(P)
{
	const special = () => P.special;

	const proxyProductionImages = useProxyProductionImages();

	return (<>
		{/* The same render the carousel shows, at the overlay's full width. A special whose poster
		    hasn't been captured yet drops straight through to the details below it. */}
		<Show when={specialPosterUrl(special(),proxyProductionImages)}>{url =>
			<img class={imgStyle()} src={url()}/>
		}</Show>

		<div class={detailsStyle()}>
			<Show when={special().name}>
				<div class={specialNameStyle()}>
					{special().name}
				</div>
			</Show>

			<div class={dateStyle()}>
				{P.times.customLabel ?? <DateTitleWithEndTimes {...P.times}/> } 
			</div>

			<Show when={special().tagline}>
				<div class={taglineStyle()}>
					{special().tagline}
				</div>
			</Show>

			<div class={moreEventTaglineStyle()} innerHTML={special().moreInfo} />
		</div>
	</>);
}

